import Language from "../utility/language"
import definedLanguages from "../translations/all"

const languageIds = []

const languages = (() => {
    const languages = {}
    var firstLang = null
    for(var i = 0; i < definedLanguages.length; i++) {
        const record = definedLanguages[i]
        const language = new Language(record[0], record[1], record[2], record[3], firstLang)
        languageIds.push(record[0])
        languages[record[0]] = language
        if (firstLang === null) {
            firstLang = language
        }
    }
    return languages
})()

const browserLanguage = (() => {
    for (var i = 0; i < languageIds.length; i++) {
        const code = languageIds[i]
        if (languages[code].matchBrowser()) {
            return languages[code]
        }
    }
    return languages[languageIds[0]]
})()

function writeLanguageIndexToStorage(languageIndex)
{
    if (window.localStorage) {
        window.localStorage.setItem("singular-key-lang", languageIds[languageIndex])
    }
    
}

function readLanguageIndexFromStorage()
{
    if (window.localStorage) {
        var lang = window.localStorage.getItem("singular-key-lang")
        if (lang === null || lang === undefined) {
            lang = browserLanguage.getCode()
        }
        if (lang !== null && lang !== undefined) {
            for (var i = 0; i < languageIds.length; i++) {
                if (languageIds[i] === lang) {
                    return i
                }
            }
        }
    }
    return 0
}

class LanguageStorage
{
    constructor()
    {
        this.languageIndex = readLanguageIndexFromStorage()
        this.write()
        this.callback = null
    }

    setCallback(callback)
    {
        this.callback = callback
    }

    nextLanguage()
    {
        this.languageIndex = (this.languageIndex + 1) % languageIds.length
        this.write()
    }

    getAllLanguages()
    {
        return languageIds.map(languageId => languages[languageId])
    }

    selectLanguage(language)
    {
        for (var i = 0; i < languageIds.length; i++) {
            if (languageIds[i] === language) {
                this.languageIndex = i
                this.write()
                return
            }
        }
    }

    getSelectedLanguage()
    {
        return languageIds[this.languageIndex]
    }

    getLanguage(languageId = null)
    {
        if (languageId === null || languageId === undefined) {
            languageId = this.getSelectedLanguage()
        }
        return languages[languageId]
    }

    write()
    {
        writeLanguageIndexToStorage(this.languageIndex)
        if (this.callback !== null && this.callback !== undefined) {
            this.callback.call(null, this.getLanguage())
        }
    }
}

export default new LanguageStorage

